<template>
  <div class="download-loading" v-show="showAIProcessLoading">
    <div class="download-loading__content">
      <div class="download-loading__lottie">
        <!-- <LottieAnimation
          :animationData="require('@/assets/lottie/download.json')"
          :loop="true"
          :autoPlay="true"
          :speed="1"
        /> -->
        <svg
          id="aiLoaderSvg"
          viewBox="0 0 400 400"
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          style="user-select: none"
        >
          <!-- 1. 信號波 (Antenna waves) -->
          <circle cx="180" cy="105" r="18" fill="none" stroke="#f95e49" class="signal-wave" />
          <circle
            cx="180"
            cy="105"
            r="18"
            fill="none"
            stroke="#f95e49"
            class="signal-wave"
            style="animation-delay: 0.4s"
          />
          <circle
            cx="180"
            cy="105"
            r="18"
            fill="none"
            stroke="#f95e49"
            class="signal-wave"
            style="animation-delay: 0.8s"
          />

          <!-- 2. 二星芒 (Sparkles) -->
          <!-- 左星芒 -->
          <g class="anim-twinkle-1">
            <path
              d="M 130,68 Q 130,80 142,80 Q 130,80 130,92 Q 130,80 118,80 Q 130,80 130,68 Z"
              fill="#f3b723"
              stroke="#1d1d1d"
              stroke-width="4"
              stroke-linejoin="round"
            />
          </g>
          <!-- 右星芒 -->
          <g class="anim-twinkle-2">
            <path
              d="M 320,198 Q 320,210 332,210 Q 320,210 320,222 Q 320,210 308,210 Q 320,210 320,198 Z"
              fill="#f3b723"
              stroke="#1d1d1d"
              stroke-width="4"
              stroke-linejoin="round"
            />
          </g>

          <!-- 3. 動態對話泡泡 (Speech Bubble) -->
          <g class="bubble-sway">
            <!-- 對話框主體與尾巴一體化 path (包含超厚黑框與黃色填充) -->
            <path
              d="M 228,30
                         H 342
                         A 18,18 0 0,1 360,48
                         V 102
                         A 18,18 0 0,1 342,120
                         H 260
                         L 205,150
                         L 235,120
                         H 228
                         A 18,18 0 0,1 210,102
                         V 48
                         A 18,18 0 0,1 228,30 Z"
              fill="#f3b723"
              stroke="#1d1d1d"
              stroke-width="6"
              stroke-linejoin="round"
              stroke-linecap="round"
            />

            <!-- 數據文字 0101 / 1010 (等寬字型呈現處理數據中) -->
            <text
              x="285"
              y="68"
              font-family="'Inconsolata', monospace, sans-serif"
              font-size="28"
              font-weight="900"
              fill="#1d1d1d"
              text-anchor="middle"
              letter-spacing="4"
            >
              <tspan class="bin-flicker-1" id="bin0_0">0</tspan>
              <tspan class="bin-flicker-2" id="bin0_1">1</tspan>
              <tspan class="bin-flicker-3" id="bin0_2">0</tspan>
              <tspan class="bin-flicker-4" id="bin0_3">1</tspan>
            </text>
            <text
              x="285"
              y="100"
              font-family="'Inconsolata', monospace, sans-serif"
              font-size="28"
              font-weight="900"
              fill="#1d1d1d"
              text-anchor="middle"
              letter-spacing="4"
            >
              <tspan class="bin-flicker-4" id="bin1_0">1</tspan>
              <tspan class="bin-flicker-3" id="bin1_1">0</tspan>
              <tspan class="bin-flicker-2" id="bin1_2">1</tspan>
              <tspan class="bin-flicker-1" id="bin1_3">0</tspan>
            </text>
          </g>

          <!-- 4. 機器人主體 (Robot Body) -->
          <g class="anim-float">
            <!-- 脖子 (Neck) -->
            <rect
              x="160"
              y="284"
              width="40"
              height="25"
              fill="#a4abb6"
              stroke="#1d1d1d"
              stroke-width="6"
              stroke-linejoin="round"
            />

            <!-- 天線桿 (Antenna shaft) -->
            <line
              x1="180"
              y1="160"
              x2="180"
              y2="120"
              stroke="#1d1d1d"
              stroke-width="6"
              stroke-linecap="round"
            />

            <!-- 機器人頭部主體 (Robot head) -->
            <rect
              x="100"
              y="160"
              width="160"
              height="130"
              rx="20"
              ry="20"
              fill="var(--robot-body)"
              stroke="#1d1d1d"
              stroke-width="6"
              stroke-linejoin="round"
            />

            <!-- 頭部高光 (Highlight) -->
            <path
              d="M 112,255 L 112,182 A 10,10 0 0,1 122,172"
              fill="none"
              stroke="var(--robot-body-highlight)"
              stroke-width="5"
              stroke-linecap="round"
            />

            <!-- 頭部下方立體陰影 (Bottom inner shadow) -->
            <path
              d="M 115,275 L 245,275"
              fill="none"
              stroke="var(--robot-body-shadow)"
              stroke-width="5"
              stroke-linecap="round"
            />

            <!-- 天線紅球 (Antenna bulb) -->
            <circle
              cx="180"
              cy="105"
              r="18"
              fill="#f95e49"
              stroke="#1d1d1d"
              stroke-width="6"
              class="red-pulse"
            />
            <!-- 紅球亮點 (Bulb spec light) -->
            <circle cx="174" cy="99" r="4" fill="#ffffff" />

            <!-- 左眼 (Left eye) -->
            <circle
              cx="145"
              cy="215"
              r="22"
              fill="#ffffff"
              stroke="#1d1d1d"
              stroke-width="6"
              class="eye-blink"
            />
            <!-- 右眼 (Right eye) -->
            <circle
              cx="215"
              cy="215"
              r="22"
              fill="#ffffff"
              stroke="#1d1d1d"
              stroke-width="6"
              class="eye-blink-right"
            />

            <!-- 網格嘴巴 (Mouth) -->
            <rect
              x="132"
              y="250"
              width="96"
              height="20"
              rx="10"
              fill="#ffffff"
              stroke="#1d1d1d"
              stroke-width="6"
            />
            <!-- 嘴巴齒狀柵格線 -->
            <line x1="151" y1="250" x2="151" y2="270" stroke="#1d1d1d" stroke-width="4" />
            <line x1="170" y1="250" x2="170" y2="270" stroke="#1d1d1d" stroke-width="4" />
            <line x1="190" y1="250" x2="190" y2="270" stroke="#1d1d1d" stroke-width="4" />
            <line x1="209" y1="250" x2="209" y2="270" stroke="#1d1d1d" stroke-width="4" />

            <!-- 臉頰高光/貼圖 (Cheek accents) -->
            <path
              d="M 108,245 A 2,2 0 0,1 112,245"
              fill="none"
              stroke="#ffffff"
              stroke-width="4"
              stroke-linecap="round"
            />
            <path
              d="M 248,245 A 2,2 0 0,1 252,245"
              fill="none"
              stroke="#ffffff"
              stroke-width="4"
              stroke-linecap="round"
            />
          </g>
        </svg>
      </div>
      <p class="download-loading__text">
        {{ showAIProcessLoadingText || '資料處理中，請不要離開此畫面，感謝您的耐心等候。' }}
      </p>
    </div>
  </div>
</template>
<script>
//import LottieAnimation from 'lottie-web-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AIProcessLoading',
  components: {
    //LottieAnimation,
  },
  computed: {
    ...mapGetters(['showAIProcessLoading', 'showAIProcessLoadingText']),
  },
}

// 定時隨機切換對話框中的 0 / 1，模擬 AI 即時運算的行為
setInterval(() => {
  for (let r = 0; r < 2; r++) {
    for (let c = 0; c < 4; c++) {
      if (Math.random() > 0.75) {
        const cell = document.getElementById(`bin${r}_${c}`)
        if (cell) {
          cell.textContent = cell.textContent === '0' ? '1' : '0'
        }
      }
    }
  }
}, 400)
</script>

<style lang="scss" scoped>
$overlayColor: rgba(0, 0, 0, 0.75);
$textColor: #eee;

.download-loading {
  display: flex;
  width: 100%;
  height: 100dvh;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  background-color: $overlayColor;
  z-index: 9999 !important;

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__lottie {
    max-width: 300px;
    margin: 0 auto;
  }

  &__text {
    color: $textColor;
    font-size: 1rem;
    letter-spacing: 0.1em;
    line-height: 1.5rem;
    text-align: center;
    padding: 0 1rem;
  }
}
</style>

<style>
/* 頁面基本重置，確保動畫完美置中與全螢幕無邊界 */
/* body, html {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center; */
/* 調整為 50% 透明度的穿透感淺灰色 */
/* background-color: rgba(235, 238, 242, 0.5);  */
/* 加上毛玻璃/磨砂效果，增強有質感的穿透透光感 */
/* backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            overflow: hidden;
        } */

/* ---------------- 主題配色與動畫變數 ---------------- */
:root {
  /* 經典晴空藍風格配角顏色 */
  --robot-body: #60b1e4;
  --robot-body-shadow: #258cc5;
  --robot-body-highlight: #bfe5ff;

  /* 動畫週期時間 */
  --float-dur: 3s;
  --pulse-dur: 1.2s;
  --twinkle-dur: 2s;
  --binary-flicker: 0.8s;
}

/* 限制動畫容器為正方形，最大 512x512 比例 */
.anim-container {
  width: 90vw;
  height: 90vh;
  max-width: 512px;
  max-height: 512px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ---------------- 動畫 Keyframes ---------------- */

/* 1. 機器人整體漂浮與呼吸感 */
.anim-float {
  animation: robotFloat var(--float-dur) ease-in-out infinite;
}
@keyframes robotFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-12px) rotate(1deg);
  }
}

/* 2. 天線信號發射波 */
.signal-wave {
  transform-origin: 180px 105px;
  animation: signalPulse var(--pulse-dur) cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}
@keyframes signalPulse {
  0% {
    transform: scale(0.6);
    opacity: 1;
    stroke-width: 8;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
    stroke-width: 2;
  }
}

/* 3. 星芒閃爍與旋轉 */
.anim-twinkle-1 {
  transform-origin: 130px 80px;
  animation: twinkle var(--twinkle-dur) ease-in-out infinite;
}
.anim-twinkle-2 {
  transform-origin: 320px 210px;
  animation: twinkle var(--twinkle-dur) ease-in-out infinite;
  animation-delay: 0.5s;
}
@keyframes twinkle {
  0%,
  100% {
    transform: scale(0.3) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.1) rotate(90deg);
    opacity: 1;
  }
}

/* 4. 天線紅球縮放呼吸 */
.red-pulse {
  transform-origin: 180px 105px;
  animation: bulbPulse var(--pulse-dur) ease-in-out infinite alternate;
}
@keyframes bulbPulse {
  0% {
    transform: scale(0.9);
    filter: drop-shadow(0 0 2px #f95e49);
  }
  100% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 12px #f95e49);
  }
}

/* 5. 眼睛動態眨眼 */
.eye-blink {
  transform-origin: 145px 215px;
  animation: blinkEye 4s ease-in-out infinite;
}
.eye-blink-right {
  transform-origin: 215px 215px;
  animation: blinkEye 4s ease-in-out infinite;
}
@keyframes blinkEye {
  0%,
  96%,
  100% {
    transform: scaleY(1);
  }
  98% {
    transform: scaleY(0.1);
  }
}

/* 6. 對話框微幅彈性晃動 */
.bubble-sway {
  transform-origin: 205px 150px;
  animation: bubbleSway var(--float-dur) ease-in-out infinite;
  animation-delay: 0.2s;
}
@keyframes bubbleSway {
  0%,
  100% {
    transform: translate(0px, 0px) scale(1);
  }
  50% {
    transform: translate(4px, -4px) scale(1.02);
  }
}

/* 7. 二進位文字閃爍效果 */
.bin-flicker-1 {
  animation: textFlicker var(--binary-flicker) steps(2) infinite;
}
.bin-flicker-2 {
  animation: textFlicker var(--binary-flicker) steps(2) infinite;
  animation-delay: 0.2s;
}
.bin-flicker-3 {
  animation: textFlicker var(--binary-flicker) steps(2) infinite;
  animation-delay: 0.4s;
}
.bin-flicker-4 {
  animation: textFlicker var(--binary-flicker) steps(2) infinite;
  animation-delay: 0.6s;
}

@keyframes textFlicker {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
</style>
